import { useState, useEffect, useContext, useRef } from 'react';

import { PracticeReseveContext } from '../../../../PracticeReseveContext';


function PracticeReserveSelectInstructorRequest(props: any) {

  const { user } = useContext(PracticeReseveContext);

  return (
    <div className="modal-content" style={{backgroundColor: '#eee'}}>
      <div style={{padding: '10px 0'}}>
        <h4 className="modal-title text-center" style={{fontWeight: 'bold'}}>講師リクエスト</h4>
      </div>
      <div className="modal-body" style={{paddingTop: 0}}>
        <div className="panel-body" style={{padding: 0, margin: 0}}>
          <form action="/inquiry" method="post">
            <input type="hidden" name="mode" value="1" />
            <input type="hidden" name="name" value={user.name} />
            <input type="hidden" name="email" value={user.email} />
            <input type="hidden" name="category" value="45" />
            <div className="form-group">
              <div className="controls">
                <textarea
                  id="contact-message"
                  name="body"
                  placeholder="お問い合わせ内容をご記入ください"
                  className="form-control requiredField"
                  data-new-placeholder="Your message"
                  rows={22}
                  data-error-empty="内容を入力してください"
                  style={{ fontWeight: "normal" }}
                  defaultValue={`■プラクティス
講師リクエスト

■ご希望の日時
※リクエストの確認にお時間をいただくため、希望日は3日以上先の日程をご記入ください。
第一希望：
第二希望：
第三希望：

（記入例）
第一希望： 3/20 09:00〜12:00
第二希望： 3/22 14:00〜16:00
第三希望： 3/30 22:00～22:30　など

■ご希望の時間（15分、30分）

■ご希望の講師

■ご希望のレッスン内容（任意）

                  `}
                />
              </div>
            </div>
            <div className="text-center">
              <button name="submit" type="submit" className="btn btn-success btn_customize" style={{margin: '5px'}}>
                リクエスト内容を送信する
                <i className="fas fa-chevron-circle-right" style={{marginLeft: 10}}></i>
              </button>
            </div>
            <div className="small" style={{marginTop: '15px'}}>
              ※ 希望講師の都合により、ご予約が出来ない場合がございます。予めご了承ください。<br />
              ※ 希望時間に応じて、予約チケット枚数が変化します。（15分3チケット、30分6チケット）<br />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
  
export default PracticeReserveSelectInstructorRequest;